/**
 * Cloud Spend API
 * Functions for fetching GCP and Twilio billing data
 */

import { api } from '@/lib/api';
import type { CloudSpendResponse, TwilioSpendResponse, AWSSpendResponse, OpenAISpendResponse, DeepgramSpendResponse } from './types';

/**
 * Fetch cloud spend data from the backend
 * Returns current month and previous month comparison
 */
export async function getCloudSpend(): Promise<CloudSpendResponse> {
  return api.get<CloudSpendResponse>('/v4/cloud-spend');
}

/**
 * Fetch cloud spend data for a specific date range
 */
export async function getCloudSpendByRange(
  startDate: string,
  endDate: string
): Promise<CloudSpendResponse> {
  return api.get<CloudSpendResponse>('/v4/cloud-spend', {
    startDate,
    endDate,
  });
}

/**
 * Fetch Twilio spend data from the backend
 * Returns current month and previous month comparison
 */
export async function getTwilioSpend(): Promise<TwilioSpendResponse> {
  return api.get<TwilioSpendResponse>('/v4/cloud-spend/twilio');
}

/**
 * Fetch AWS spend data from the backend
 * Returns current month and previous month comparison
 */
export async function getAwsSpend(): Promise<AWSSpendResponse> {
  return api.get<AWSSpendResponse>('/v4/cloud-spend/aws');
}

/**
 * Fetch OpenAI spend data from the backend
 * Returns current month and previous month comparison
 */
export async function getOpenaiSpend(): Promise<OpenAISpendResponse> {
  return api.get<OpenAISpendResponse>('/v4/cloud-spend/openai');
}

/**
 * Fetch Deepgram spend data from the backend
 * Returns current month and previous month comparison
 */
export async function getDeepgramSpend(): Promise<DeepgramSpendResponse> {
  return api.get<DeepgramSpendResponse>('/v4/cloud-spend/deepgram');
}
